/**
 * Registers the standalone "add to chat context" button on the framework's
 * Jotai store so `ModelDetailView` renders it in every entity detail
 * header — giving RFLP entities (Project, Action, LogicalPart,
 * PhysicalPart, Requirement, …) the same add-to-context affordance the
 * bespoke PDM layouts already have.
 *
 * Mirrors `config/field-overrides`: a side-effect import from the main
 * layout, so it works for every route without a Provider wrapper.
 */

import { setAddToContextButton } from "@sourcepilot/ui/framework/ui/views";
import { AddToContextButton } from "@/ui/molecules/add-to-context-button";

setAddToContextButton(AddToContextButton);
